import { ComponentProps, FC, ReactNode } from 'react';
import {
  CheckCircleIconOutline,
  ExclamationCircleIconOutline,
  ExclamationIconOutline,
  InformationCircleIconOutline,
} from 'utils/icons';

// in figma, this is called "Style"
export type AlertVariant = 'filled' | 'white';

// in figma, this is called "Status"
export type AlertType =
  | 'error'
  | 'warning'
  | 'success'
  | 'information'
  | 'neutre'
  | 'primary'
  | 'ai';

type AlertPropsBase = {
  type: AlertType;
  variant?: AlertVariant;
  icon?: FC<ComponentProps<'svg'>>;
  renderIcon?: (className?: string) => ReactNode;
  title?: string | ReactNode;
  description?: string | ReactNode;
  primaryAction?: {
    label: string;
    onClick: () => void;
    tracingEvent?: string;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
    tracingEvent?: string;
  };
  dismissible?: boolean;
  onDismiss?: () => void;
  dismissId?: string;
  className?: string;
  actions?: ReactNode;
  withAldo?: boolean;
  extra?: ReactNode;
};

type AlertPropsSmall = AlertPropsBase & {
  size: 'x-small' | 'small';
};

type AlertPropsLarge = AlertPropsBase & {
  size: 'large' | 'large-mid';
};

export type AlertProps = AlertPropsSmall | AlertPropsLarge;

export const AlertV2IconMap: Record<AlertType, FC<ComponentProps<'svg'>>> = {
  error: ExclamationCircleIconOutline,
  warning: ExclamationIconOutline,
  success: CheckCircleIconOutline,
  information: InformationCircleIconOutline,
  neutre: ExclamationCircleIconOutline,
  primary: ExclamationCircleIconOutline,
  ai: ExclamationCircleIconOutline,
};
